import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import useIsMobile from '../hooks/useIsMobile';
import homesLogo from '../assets/HOMES_LOGO.webp';

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="header-homes">
      <div 
        className="header-container"
        style={{
          flexDirection: isMobile ? 'column' : 'row',
          padding: isMobile ? '10px' : '20px',
          gap: isMobile ? '10px' : '20px'
        }}
      >
        <div 
          className="header-logo"
          style={{
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: 'center',
            textAlign: isMobile ? 'center' : 'left'
          }}
        >
          <img 
            src={homesLogo} 
            alt="HOMES Logo" 
            className="homes-logo"
            style={{
              maxWidth: isMobile ? '100px' : '150px',
              marginBottom: isMobile ? '8px' : '0'
            }}
          />
          <h1 style={{
            fontSize: isMobile ? '1.2rem' : '1.8rem',
            marginLeft: isMobile ? '0' : '15px'
          }}>
            Gestor de Expedientes {!isMobile && 'Técnicos'}
          </h1>
        </div>
        {user && (
          <div 
            className="header-user"
            style={{
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: isMobile ? 'stretch' : 'center',
              gap: isMobile ? '8px' : '15px',
              width: isMobile ? '100%' : 'auto'
            }}
          >
            <span 
              className="user-name"
              style={{
                fontSize: isMobile ? '0.9rem' : '1rem',
                textAlign: isMobile ? 'center' : 'right'
              }}
            >
              {isMobile ? user.nombre.split(' ')[0] : `Bienvenido, ${user.nombre}`}
            </span>
            <button 
              onClick={handleLogout} 
              className="btn-homes-outline btn-sm"
              style={{
                width: isMobile ? '100%' : 'auto',
                padding: isMobile ? '10px' : '6px 12px'
              }}
            >
              <i className="fas fa-sign-out-alt"></i> Cerrar Sesión
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;





